/* =========================================================
   Southern Made – product page layout
   <sm-pdp-gallery>  thumbnails + main image (swipe on mobile),
                     follows the selected variant, zoom lightbox
   Layout helpers    title + price row, short description after the
                     reviews, trust icons under checkout, size guide link,
                     TeeInBlue preview takes over the gallery when present
   The theme's own blocks (variant picker, add to cart, Shop Pay, pickup,
   share) and TeeInBlue keep working exactly as before.
   ========================================================= */
(function () {
  /* ---------- variant change signal (theme updates ?variant= in the URL) ---------- */
  if (!window.SmVariantSignal) {
    window.SmVariantSignal = true;
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function () {
        var r = orig.apply(this, arguments);
        try { document.dispatchEvent(new CustomEvent('sm:url')); } catch (e) {}
        return r;
      };
    });
    window.addEventListener('popstate', function () { document.dispatchEvent(new CustomEvent('sm:url')); });
  }
  function currentVariant() {
    try { return new URL(window.location.href).searchParams.get('variant'); } catch (e) { return null; }
  }

  /* =========================================================
     Gallery
     ========================================================= */
  if (!customElements.get('sm-pdp-gallery')) {
    class SmPdpGallery extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        try { this.data = JSON.parse(this.querySelector('[data-gal-data]').textContent); } catch (e) { this.data = { variants: {}, full: [] }; }
        this.track = this.querySelector('[data-gal-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.SmGal__Slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.SmGal__Thumb'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.SmGal__Dots span'));
        this.thumbTrack = this.querySelector('.SmGal__ThumbTrack');
        this.lb = this.querySelector('.SmGal__Lightbox');
        this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

        /* start on the selected variant's image */
        requestAnimationFrame(function () { self.go(self.index, false); self.thumbNavState(); });

        this.addEventListener('click', function (e) {
          var t = e.target;
          var thumb = t.closest('.SmGal__Thumb');
          if (thumb) { self.go(parseInt(thumb.dataset.index, 10), true); return; }
          var step = t.closest('[data-gal-step]');
          if (step) { self.go(self.index + parseInt(step.dataset.galStep, 10), true); return; }
          var nav = t.closest('[data-thumb-nav]');
          if (nav) { self.scrollThumbs(parseInt(nav.dataset.thumbNav, 10)); return; }
          if (t.closest('[data-gal-zoom]') || (t.matches('img') && t.closest('.SmGal__Slide[data-type="image"]') && window.matchMedia('(min-width: 990px)').matches)) {
            self.openZoom(); return;
          }
          if (t.closest('[data-lb-close]') || t === self.lb) { self.closeZoom(); return; }
          var lbs = t.closest('[data-lb-step]');
          if (lbs) { self.lbGo(self.lbIndex + parseInt(lbs.dataset.lbStep, 10)); }
        });

        /* swipe / scroll sync */
        var scrollTimer;
        this.track.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var w = self.track.clientWidth || 1;
            var i = Math.round(self.track.scrollLeft / w);
            if (i !== self.index) self.go(i, false, true);
          }, 80);
        }, { passive: true });

        this.addEventListener('keydown', function (e) {
          if (self.lb && self.lb.open) {
            if (e.key === 'ArrowRight') self.lbGo(self.lbIndex + 1);
            if (e.key === 'ArrowLeft') self.lbGo(self.lbIndex - 1);
          }
        });
        if (this.thumbTrack) this.thumbTrack.addEventListener('scroll', function () { self.thumbNavState(); }, { passive: true });
        window.addEventListener('resize', function () { self.go(self.index, false); self.thumbNavState(); });

        /* follow the selected variant */
        this.lastVariant = currentVariant();
        document.addEventListener('sm:url', function () {
          var v = currentVariant();
          if (!v || v === self.lastVariant) return;
          self.lastVariant = v;
          var mediaId = self.data.variants[v];
          if (!mediaId) return;
          var i = self.slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
          if (i > -1) self.go(i, true);
        });
      }

      go(i, smooth, fromScroll) {
        var n = this.slides.length;
        if (!n) return;
        if (i < 0) i = n - 1;
        if (i >= n) i = 0;
        this.index = i;
        this.slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        this.thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        /* pause videos that are not visible */
        this.slides.forEach(function (s, k) {
          if (k === i) return;
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        });
        if (!fromScroll) {
          var left = i * this.track.clientWidth;
          if (Math.abs(this.track.scrollLeft - left) > 2) this.track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
        }
        var active = this.thumbs[i];
        if (active && this.thumbTrack) {
          var tt = this.thumbTrack, vertical = tt.scrollHeight > tt.clientHeight + 2 && getComputedStyle(tt).flexDirection === 'column';
          if (vertical) {
            var top = active.offsetTop - tt.offsetTop;
            if (top < tt.scrollTop || top + active.offsetHeight > tt.scrollTop + tt.clientHeight) tt.scrollTo({ top: top - 8, behavior: 'smooth' });
          } else {
            var l = active.offsetLeft - tt.offsetLeft;
            if (l < tt.scrollLeft || l + active.offsetWidth > tt.scrollLeft + tt.clientWidth) tt.scrollTo({ left: l - 8, behavior: 'smooth' });
          }
        }
      }

      scrollThumbs(dir) {
        var tt = this.thumbTrack;
        if (!tt) return;
        var vertical = getComputedStyle(tt).flexDirection === 'column';
        var step = (vertical ? tt.clientHeight : tt.clientWidth) * 0.8 * dir;
        tt.scrollBy(vertical ? { top: step, behavior: 'smooth' } : { left: step, behavior: 'smooth' });
      }

      thumbNavState() {
        var tt = this.thumbTrack;
        if (!tt) return;
        var vertical = getComputedStyle(tt).flexDirection === 'column';
        var size = vertical ? tt.scrollHeight - tt.clientHeight : tt.scrollWidth - tt.clientWidth;
        var pos = vertical ? tt.scrollTop : tt.scrollLeft;
        this.classList.toggle('SmGal--thumbOverflow', size > 4);
        this.classList.toggle('SmGal--thumbStart', pos <= 2);
        this.classList.toggle('SmGal--thumbEnd', pos >= size - 2);
      }

      openZoom() {
        if (!this.lb || !this.data.full.length) return;
        this.lbGo(this.index);
        if (typeof this.lb.showModal === 'function') this.lb.showModal(); else this.lb.setAttribute('open', '');
        document.documentElement.classList.add('SmBulk-open');
        var self = this;
        this.lb.addEventListener('close', function () { document.documentElement.classList.remove('SmBulk-open'); }, { once: true });
      }
      closeZoom() {
        if (!this.lb) return;
        if (this.lb.open && typeof this.lb.close === 'function') this.lb.close(); else this.lb.removeAttribute('open');
        document.documentElement.classList.remove('SmBulk-open');
      }
      lbGo(i) {
        var n = this.data.full.length;
        if (!n) return;
        if (i < 0) i = n - 1;
        if (i >= n) i = 0;
        this.lbIndex = i;
        var img = this.lb.querySelector('.SmGal__LbImg');
        img.src = this.data.full[i];
        var a = this.slides[i] && this.slides[i].querySelector('img');
        img.alt = a ? a.alt : '';
        var c = this.lb.querySelector('.SmGal__LbCount');
        if (c) c.textContent = (i + 1) + ' / ' + n;
      }
    }
    customElements.define('sm-pdp-gallery', SmPdpGallery);
  }

  /* =========================================================
     Layout helpers
     ========================================================= */
  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="8" width="20" height="8" rx="1"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg>';

  function ownText(el) {
    var t = '';
    el.childNodes.forEach(function (c) { if (c.nodeType === 3) t += c.textContent; });
    return t.trim();
  }

  function titleRow(root) {
    var title = root.querySelector('.Product__Block--title');
    var price = root.querySelector('.Product__Block--price');
    if (!title || !price) return;
    var row = title.parentElement && title.parentElement.classList.contains('SmPdp__TitleRow') ? title.parentElement : null;
    if (row && price.parentElement === row) return;
    if (!row) {
      row = document.createElement('div');
      row.className = 'SmPdp__TitleRow';
      title.parentNode.insertBefore(row, title);
      row.appendChild(title);
    }
    row.appendChild(price);
  }

  function placeAfter(el, ref) {
    if (!el || !ref || !ref.parentNode) return;
    if (ref.nextElementSibling !== el) ref.insertAdjacentElement('afterend', el);
  }

  function shortDesc(root) {
    var el = root.querySelector('[data-sm-part="short"]');
    if (!el) return;
    var rating = root.querySelector('.Product__Block--rating');
    var ref = rating && rating.textContent.trim() !== '' ? rating : (root.querySelector('.SmPdp__TitleRow') || root.querySelector('.Product__Block--title'));
    placeAfter(el, ref);
  }

  function trust(root) {
    var el = root.querySelector('[data-sm-part="trust"]');
    if (!el) return;
    var tee = root.querySelector('#teeFormActions, .tee-form-actions');
    var ref = null;
    if (tee) {
      ref = root.querySelector('.SmBulk__Trigger--tee');
      if (!ref) {
        var block = root.querySelector('.Product__Block--buyButtons');
        ref = tee;
        while (block && ref.parentElement && ref.parentElement !== block) ref = ref.parentElement;
      }
    } else {
      var bb = root.querySelector('.Product__Block--buyButtons');
      ref = bb && (bb.querySelector('.shopify-payment-button') || bb.querySelector('.SmBuyRow') || bb.querySelector('form[action*="/cart/add"]'));
      /* inside the form, sit after the payment button wrapper */
      if (ref && ref.matches('.shopify-payment-button')) {
        var p = ref;
        while (p.parentElement && p.parentElement.children.length === 1 && !p.parentElement.matches('form')) p = p.parentElement;
        ref = p;
      }
    }
    if (ref) placeAfter(el, ref);
  }

  function sizeGuide(root) {
    var dlg = root._smSize || root.querySelector('.SmSize');
    if (!dlg) return;
    root._smSize = dlg;
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    var names = (dlg.dataset.options || 'Size').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var label = dlg.dataset.label || 'Size Guide';
    var candidates = root.querySelectorAll('.Product__Block--variantPicker label, .Product__Block--variantPicker legend, .Product__Block--variantPicker span, .Product__Block--variantPicker div, .Product__Block--variantPicker p, .tee-option__title');
    candidates.forEach(function (el) {
      if (el.closest('.SmSizeLink, button, .SmOpt__Unit, .SmOpt__Item, .tee-option-inner') || el.querySelector('.SmSizeLink')) return;
      var t = (ownText(el) || (el.matches('.tee-option__title') ? el.textContent.trim() : '')).toLowerCase().replace(/[:\s]+$/, '');
      if (!t) return;
      var hit = names.some(function (n) { return t === n || t.indexOf(n + ':') === 0 || t.indexOf(n + ' ') === 0; });
      if (!hit) return;
      /* only once per option group */
      var group = el.closest('.SmOpt__Group, .tee-option') || (el.parentElement && el.parentElement.classList.contains('SmSizeRow') ? el.parentElement.parentElement : el.parentElement);
      if (group && group.querySelector('.SmSizeLink')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'SmSizeLink';
      b.innerHTML = RULER;
      b.appendChild(document.createTextNode(label));
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
      if (el.matches('.tee-option__title')) {
        /* TeeInBlue title: sits inside app markup, re-added if the app redraws */
        el.classList.add('SmSizeLabel');
        el.appendChild(b);
      } else {
        /* theme label: keep the link OUT of the label so the theme can update
           "Size: S" freely – wrap label + link in a row */
        var row = el.parentElement && el.parentElement.classList.contains('SmSizeRow') ? el.parentElement : null;
        if (!row) {
          row = document.createElement('div');
          row.className = 'SmSizeRow';
          el.parentNode.insertBefore(row, el);
          row.appendChild(el);
        }
        row.appendChild(b);
      }
    });
    if (!dlg.dataset.bound) {
      dlg.dataset.bound = '1';
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-size-close]')) dlg.close(); });
    }
  }

  /* TeeInBlue preview takes over the gallery – but only once it really shows images.
     If it stays empty, our gallery stays visible so the left column is never blank. */
  function teeHasImages(tee) {
    if (!tee) return false;
    var imgs = tee.querySelectorAll('img, canvas, svg image');
    for (var i = 0; i < imgs.length; i++) {
      var el = imgs[i];
      if (el.tagName === 'IMG' && !(el.currentSrc || el.src)) continue;
      return true;
    }
    return !!tee.querySelector('[style*="background-image"]');
  }
  function teeGallery(root) {
    var tee = root.querySelector('.SmPdp__ThemeGallery .tee-gallery-wrapper, .SmPdp__ThemeGallery .tee-gallery, .SmProduct__Media .tee-gallery-wrapper, .SmProduct__Media .tee-gallery');
    var ours = root.querySelector('sm-pdp-gallery');
    var on = !!tee && (!ours || teeHasImages(tee));
    if (on === root.classList.contains('SmProduct--teeGallery')) return;
    root.classList.toggle('SmProduct--teeGallery', on);
    if (on) {
      /* let the app's slider re-measure now that it is visible */
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 30);
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 400);
    }
  }

  /* ---------- TeeInBlue colors as swatches (same matching as the Liquid swatches) ---------- */
  function swatchIndex(root) {
    if (root._smIdx !== undefined) return root._smIdx;
    var el = root.querySelector('[data-sm-swatch-index]');
    var map = {};
    try {
      var str = el ? JSON.parse(el.textContent) : '';
      str.split('|').forEach(function (pair) {
        var k = pair.indexOf('=');
        if (k > 0 && !(pair.slice(0, k) in map)) map[pair.slice(0, k)] = pair.slice(k + 1);
      });
    } catch (e) {}
    root._smIdx = map;
    return map;
  }
  function norm(n) {
    return String(n || '').toLowerCase().replace(/[.\/\-_&|=]/g, ' ').split(/\s+/).filter(Boolean).join(' ');
  }
  function swatchBg(name, map) {
    var n = norm(name), out = map[n] || map[n.replace(/ /g, '')] || '';
    if (!out && n) {
      var w = n.split(' '), i = 0, parts = [];
      while (i < w.length) {
        var used = 1;
        for (var len = w.length - i; len > 0; len--) {
          var c = w.slice(i, i + len).join(' ');
          if (map[c]) { parts.push(map[c]); used = len; break; }
        }
        i += used;
      }
      out = parts.join('/');
    }
    if (!out) out = '#d6d1c7';
    var cols = out.split('/').filter(Boolean);
    if (cols.length < 2) return cols[0];
    return 'linear-gradient(135deg,' + cols.map(function (c, k) {
      return c + ' ' + Math.round(k * 100 / cols.length) + '% ' + Math.round((k + 1) * 100 / cols.length) + '%';
    }).join(',') + ')';
  }
  function teeSwatches(root) {
    if (!root.classList.contains('SmProduct--teeSwatches')) return;
    var opt = root.querySelector('.tee-option--color');
    if (!opt) return;
    var map = swatchIndex(root);
    var inner = opt.querySelector('.tee-option-inner');
    if (inner) inner.classList.add('SmTeeSwatches');
    opt.querySelectorAll('.tee-radio-label').forEach(function (lab) {
      var name = lab.getAttribute('title') || lab.textContent.trim();
      if (lab.dataset.smSw !== name) {
        lab.dataset.smSw = name;
        lab.classList.add('SmTeeSwatch');
        lab.style.setProperty('background', swatchBg(name, map), 'important');
        lab.setAttribute('aria-label', name);
      }
    });
    /* "Color: Hot Pink White" next to the option title */
    var title = opt.querySelector('.tee-option__title');
    var active = opt.querySelector('.tee-radio.active .tee-radio-label, .tee-radio input:checked + .tee-radio-label');
    if (title && active) {
      var sel = title.querySelector('.SmTeeSel');
      var txt = active.getAttribute('title') || active.textContent.trim();
      if (!sel) { sel = document.createElement('span'); sel.className = 'SmTeeSel'; title.appendChild(sel); }
      if (sel.textContent !== txt) sel.textContent = txt;
    }
  }

  /* ---------- TeeInBlue: quantity on its own line, ADD TO CART 50% | BULK 50% ---------- */
  function teeAtcRow(root) {
    var wrap = root.querySelector('.tee-form-atc-wrapper');
    var atc = wrap && wrap.querySelector('.tee-btn--atc');
    var trig = root.querySelector('.SmBulk__Trigger');
    if (!wrap || !atc || !trig) return;
    wrap.classList.add('SmTeeAtcRow');
    var host = trig.parentElement;
    var desktop = window.matchMedia('(min-width: 768px)').matches;
    if (!desktop) {
      if (trig.classList.contains('SmBulk__Trigger--teeSide')) {
        trig.classList.remove('SmBulk__Trigger--teeSide');
        trig.style.cssText = '';
      }
      return;
    }
    host.classList.add('SmTeeHost');
    trig.classList.add('SmBulk__Trigger--teeSide');
    var h = host.getBoundingClientRect(), a = atc.getBoundingClientRect();
    if (!a.width) return;
    var gap = 12;
    var top = Math.round(a.top - h.top), left = Math.round(a.right - h.left + gap);
    var width = Math.round(Math.max(120, (wrap.getBoundingClientRect().right - a.right) - gap));
    var css = 'top:' + top + 'px;left:' + left + 'px;width:' + width + 'px;height:' + Math.round(a.height) + 'px;';
    if (trig.style.cssText.replace(/\s/g, '') !== css) trig.style.cssText = css;
  }

  function run(root) {
    titleRow(root);
    shortDesc(root);
    trust(root);
    sizeGuide(root);
    teeGallery(root);
    teeSwatches(root);
    teeAtcRow(root);
  }

  function init() {
    document.querySelectorAll('.SmProduct--pdp').forEach(function (root) {
      if (root.dataset.smPdp) return;
      root.dataset.smPdp = '1';
      run(root);
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; run(root); });
      }).observe(root, { childList: true, subtree: true });
      var checks = 0;
      var timer = setInterval(function () { teeGallery(root); if (++checks > 20) clearInterval(timer); }, 500);
      root.addEventListener('load', function () { teeGallery(root); teeAtcRow(root); }, true);
      window.addEventListener('resize', function () { teeAtcRow(root); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { teeAtcRow(root); }).observe(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
